import { Link, useRouteError, isRouteErrorResponse } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Home, ArrowLeft, AlertTriangle } from 'lucide-react'

export function NotFoundPage() {
  const error = useRouteError()
  const is404 = isRouteErrorResponse(error) && error.status === 404

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
      <div className="text-center space-y-6 max-w-md">
        {is404 ? (
          <>
            <div className="text-8xl font-bold text-muted-foreground/30">404</div>
            <h1 className="text-2xl font-semibold">Page not found</h1>
            <p className="text-muted-foreground">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </>
        ) : (
          <>
            <div className="flex justify-center">
              <AlertTriangle className="h-16 w-16 text-destructive/70" />
            </div>
            <h1 className="text-2xl font-semibold">Something went wrong</h1>
            <p className="text-muted-foreground">
              {isRouteErrorResponse(error)
                ? error.statusText
                : error instanceof Error
                ? error.message
                : 'An unexpected error occurred'}
            </p>
          </>
        )}

        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
          <Button variant="outline" onClick={() => window.history.back()}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go back
          </Button>
          <Link to="/dashboard">
            <Button>
              <Home className="mr-2 h-4 w-4" />
              Dashboard
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
